import type { FaireProductEntity } from "../../entity_types/product";

export const p_pztgvavf48: FaireProductEntity = {
  token: "p_pztgvavf48",
  type: "product",
  name: "Farmhouse\u00a0Horse Glass Storage Jar, Rustic\u00a0Kitchen Canister",
  brandName: "Countrycore Home & Bath",
  imageUrl:
    "https://cdn.faire.com/fastly/cae6dceddc8b20474fb579a2fc7a3e9ab89b90a4ffe41081105a6dcc173aa463.jpeg",
  priceDollars: 14,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6dd3c8e854810bf2e4f6b61d7c807e9aa01658a30fd7c2839acc71badc4218f9.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
